export const TIME_OPTIONS = [
  { label: "All", value: "" },
  { label: "1 day", value: "24h" },
  { label: "1 week", value: "1w" },
  { label: "1 month", value: "1m" },
  { label: "3 months", value: "3m" },
  { label: "6 months", value: "6m" },
  { label: "1 year", value: "1y" },
] as const;

export const PREMIUM_TIME_OPTIONS = [
  { label: "1 hour", value: "1h" },
  { label: "2 hour", value: "2h" },
  { label: "4 hour", value: "4h" },
] as const;

export type TimeRangeValue =
  | (typeof TIME_OPTIONS)[number]["value"]
  | (typeof PREMIUM_TIME_OPTIONS)[number]["value"]
  | null;

export const allTimeOptions = [...TIME_OPTIONS, ...PREMIUM_TIME_OPTIONS];
